module.exports = __webpack_public_path__ + "img/liangcheng.f6f14396.png";